(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .controller('PatrimoinePropertyModalController', PatrimoinePropertyModalController);


    function PatrimoinePropertyModalController($scope, swif, patrimoinePropertyService) {
        'ngInject';
        var service = patrimoinePropertyService;
        console.log('init PatrimoinePropertyModalController');
        $scope.choices = {
            states: service.STATES_CHOICES
        };
        $scope.STATES = service.STATES_OBJ;
        $scope.filters = {
            category: {},
            consumable: {},
            supplier: {}
        };
        swif.data.addFilter($scope.filters.supplier, 'type_id.product_supplier', '=', true);
        if ($scope.model.qty === undefined) {
            $scope.model.qty = 1;
        }
        $scope.$watch('model.state', watchState);
        $scope.$watch('model.category_id', watchCategoryId);
        $scope.$watch('model.consumable_id', watchConsumable);
        $scope.$watch('model.life_duration', watchLifeDuration);


        function watchState(newV) {
            if (_.isString(newV)) {
                $scope.model.state = [newV, $scope.STATES[newV]];
            }
        }
        function watchCategoryId(newV, oldV) {
            $scope.filters.consumable = {};
            if (newV) {
                if (_.isEmpty($scope.model.name)) {
                    $scope.model.name = newV[1];
                } else {
                    if (oldV) {
                        if (oldV[1] === $scope.model.name) {
                            $scope.model.name = newV[1];
                        }
                    }
                }
                swif.data.addFilter(
                    $scope.filters.consumable, 'type_id', '=', newV[0]
                );
            }
        }
        function watchConsumable(newV) {
            if (newV) {
                var filter = {
                    fields: ['name', 'price']
                };
                if (!$scope.model.price) {
                    swif.data.get('consumable', newV[0], filter)
                    .then(function (consumable) {
                        if (consumable.price) {
                            $scope.model.price = consumable.price * $scope.model.qty;
                        }
                    });
                }
            }
        }
        function watchLifeDuration(newV) {
            if (newV) {
                if ($scope.model.date_start) {
                    //compute date end;
                    $scope.model.date_end = moment($scope.model.date_start)
                        .add(newV, 'month')
                        .format('YYYY-MM-DD');
                }
            }
        }
    }


})();
